var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { PlatformLocation } from '@angular/common';
import { ForceChangePasswordComponent } from '../force-change-password/force-change-password.component';
import { generateCaptchaNamespace, getLearnerCaptchaUrl, shouldAutoRefreshCaptcha } from '../captcha.util';
import { getErrorMsg, hasFormalLoginToken } from '../login-error.util';
var NewAppLoginComponent = (function () {
    function NewAppLoginComponent(apiService, route, router, commonService, platformLocation, cdr) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.cdr = cdr;
        // 默认登录类型
        this.signInPhone = true;
        this.signInAccount = false;
        this.isNeed2FA = false;
        //登录按钮频繁点击控制
        this.phoneLoginDisabled = false;
        this.accountLoginDisabled = false;
        this.need2FAPhoneNumber = '';
        this.twoFactoryPhone = '';
        //反馈信息
        this.messageBoxOpen = false;
        this.tipMessage = '';
        //表单bind
        this.accountName = '';
        this.accountPwd = '';
        this.phoneNumber = '';
        this.phoneVerCode = '';
        this.accountNameInvalidTips = false;
        this.accountPwdInvalidTips = false;
        this.phoneNumberInvalidTips = false;
        this.phoneVerCodeInvalidTips = false;
        this.captchaInvalidTips = false;
        this.submitData = {};
        //验证码控制
        this.phoneVerCodeStateTxt = '获取验证码';
        this.phoneVerCodeRemainSeconds = '';
        this.clickAble = true;
        this.preventFrequencyTips = false;
        this.canSendCode = true; //验证码控制
        this.isOutLink = false;
        this.targetUrl = '';
        this.assetsRoute = '../../assets';
        this.count = 0; // 连续点击次数
        this.isCheckedPhone = false; //判断是否勾选
        this.isCheckedUser = false; //判断是否勾选
        this.isAccountLogin = false;
        this.isAICoach = false;
        this.need2FAData = {};
        this.isHarmonyOS = false; //是否鸿蒙系统
        /** 图形验证码（明文提交，不做 3+1） */
        this.captchaCode = '';
        this.captchaNamespace = '';
        this.captchaImageUrl = '';
        /** 等保预校验 challenge，正式登录 / 2FA / 多公司中间态回传 */
        this.protectionChallengeToken = '';
        /** 是否需要强制修改密码 */
        this.isNeedChangePassword = false;
        /** 待完成登录的响应（强制改密通过后继续） */
        this.pendingLoginRes = null;
        /** 强制改密流程是否已占用一条 history，用于拦截浏览器回退 */
        this.forceChangeHistoryPushed = false;
        this.timerInterval = null;
    }
    NewAppLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        this.route.queryParams.subscribe(function (params) {
            _this.isAICoach = params && params['isAiCoath'] ? JSON.parse(params['isAiCoath']) : _this.isAICoach;
        });
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.targetUrl = this.platformLocation['location']['href'].split('?')[1];
        if (this.platformLocation['location']['href'].split('#').length === 2) {
            this.isAccountLogin = this.platformLocation['location']['href'].split('#')[1].indexOf('account') === -1 ? false : true;
        }
        if (this.isAccountLogin) {
            this.signInAccount = this.isAccountLogin;
            this.signInPhone = !this.isAccountLogin;
        }
        //清除从LMS平台缓存里的数据
        if (localStorage.getItem('source_env') == 'LMS_SCORM') {
            localStorage.removeItem('source_env');
        }
        this.refreshCaptcha();
    };
    /** 用户主动刷新 / 失效重拉：换新 namespace 并清空输入 */
    NewAppLoginComponent.prototype.refreshCaptcha = function () {
        this.captchaNamespace = generateCaptchaNamespace();
        this.captchaImageUrl = getLearnerCaptchaUrl(this.captchaNamespace);
        this.captchaCode = '';
        this.captchaInvalidTips = false;
    };
    /**
     * 验图请求一次消费：成功 / 失败 / 网络错误后都换新图再提交。
     */
    NewAppLoginComponent.prototype.maybeRefreshCaptchaAfterError = function (msg) {
        if (shouldAutoRefreshCaptcha(msg)) {
            this.refreshCaptcha();
        }
    };
    NewAppLoginComponent.prototype.clearProtectionChallenge = function () {
        this.protectionChallengeToken = '';
    };
    NewAppLoginComponent.prototype.validateCaptcha = function () {
        if (this.isAICoach) {
            this.captchaInvalidTips = false;
            return true;
        }
        if (!this.captchaCode || !String(this.captchaCode).trim()) {
            this.captchaInvalidTips = true;
            return false;
        }
        this.captchaInvalidTips = false;
        return true;
    };
    NewAppLoginComponent.prototype.checkMobile = function (mobile) {
        console.log('开始验证');
        var phoneReg = /^[1]([3-9])[0-9]{9}$/;
        var hongKongPattern = /^852[569]\d{7}$/;
        var taiwanPattern = /^8869\d{8}$/;
        if (!phoneReg.test(mobile) && !hongKongPattern.test(mobile) && !taiwanPattern.test(mobile)) {
            return false;
        }
        console.log('校验通过');
        return true;
    };
    NewAppLoginComponent.prototype.switchLoginType = function () {
        //登录类型切换
        this.signInAccount = !this.signInAccount;
        this.signInPhone = !this.signInPhone;
        if (this.signInPhone) {
            this.phoneNumber = '';
            clearInterval(this.timerInterval);
            this.phoneVerCode = '';
            this.accountNameInvalidTips = false;
            this.accountPwdInvalidTips = false;
            this.phoneNumberInvalidTips = false;
            this.phoneVerCodeInvalidTips = false;
            this.canSendCode = true;
            this.phoneVerCodeRemainSeconds = '';
            this.phoneVerCodeStateTxt = '获取验证码';
            //解除按钮禁用
            this.phoneLoginDisabled = this.accountLoginDisabled = false;
        }
        this.clearProtectionChallenge();
        this.refreshCaptcha();
        this.isCheckedUser = $('#checkUser').is(':checked');
        this.isCheckedPhone = $('#checkPhone').is(':checked');
    };
    NewAppLoginComponent.prototype.handleFormBlur = function () {
        console.log('blur');
        window.scroll(0, 0);
        this.commonService.initPage();
    };
    //验证账密登录
    NewAppLoginComponent.prototype.validateAccountName = function () {
        if (this.accountName == '') {
            this.accountNameInvalidTips = true;
        }
        else {
            this.accountNameInvalidTips = false;
        }
    };
    //验证账密登录
    NewAppLoginComponent.prototype.validateAccountPwd = function () {
        if (this.accountPwd == '') {
            this.accountPwdInvalidTips = true;
        }
        else {
            this.accountPwdInvalidTips = false;
        }
    };
    //验证手机号
    NewAppLoginComponent.prototype.validatePhoneNumber = function () {
        if (this.need2FAPhoneNumber && this.signInAccount) {
            this.phoneNumber = this.need2FAPhoneNumber;
        }
        if (!this.checkMobile(this.phoneNumber)) {
            //显示错误提示
            this.phoneNumberInvalidTips = true;
        }
        else {
            this.phoneNumberInvalidTips = false;
        }
    };
    NewAppLoginComponent.prototype.validatePhoneVerCode = function () {
        if (this.phoneVerCode == '') {
            return (this.phoneVerCodeInvalidTips = true);
        }
        else {
            return (this.phoneVerCodeInvalidTips = false);
        }
    };
    NewAppLoginComponent.prototype.validateCanSend = function () {
        if (!this.canSendCode) {
            this.preventFrequencyTips = true;
        }
        else {
            this.preventFrequencyTips = false;
        }
    };
    NewAppLoginComponent.prototype.startATimer = function (remainSeconds) {
        var _this = this;
        this.phoneVerCodeStateTxt = '重新获取';
        this.phoneVerCodeRemainSeconds = '(' + remainSeconds + 's)';
        this.timerInterval = setInterval(function () {
            var currentSeconds = --remainSeconds;
            _this.phoneVerCodeRemainSeconds = '(' + currentSeconds + 's)';
            if (currentSeconds === 0) {
                clearInterval(_this.timerInterval);
                _this.canSendCode = true;
                _this.phoneVerCodeRemainSeconds = '';
                _this.phoneVerCodeStateTxt = '获取验证码';
            }
        }, 1000);
    };
    // 获取验证码
    NewAppLoginComponent.prototype.getVerCode = function () {
        var _this = this;
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        //手机号验证
        this.validatePhoneNumber();
        if (this.phoneNumberInvalidTips) {
            return;
        }
        //防频繁验证
        this.validateCanSend();
        if (this.preventFrequencyTips) {
            return;
        }
        var isAccountSmsBypass = this.signInAccount && !!this.need2FAPhoneNumber;
        var needSmsCaptcha = isAccountSmsBypass && !this.isAICoach;
        if (needSmsCaptcha && !this.validateCaptcha()) {
            return;
        }
        this.canSendCode = false;
        var params = {
            phone: this.phoneNumber,
        };
        if (isAccountSmsBypass) {
            params.userName = this.commonService.encrypt(this.submitData.userName);
            params.password = this.commonService.encrypt(this.submitData.password);
        }
        if (needSmsCaptcha) {
            params.captchaCode = this.captchaCode;
            params.captchaNamespace = this.captchaNamespace;
        }
        //开启倒计时:60s
        this.apiService
            .sendCode(params)
            .subscribe(function (data) {
            //data为body内容
            console.log('测试获取验证码', data);
            if (needSmsCaptcha) {
                _this.maybeRefreshCaptchaAfterError();
            }
            if (data.success) {
                _this.startATimer(60);
            }
            else {
                _this.canSendCode = true;
                _this.tipMessage = data.message || data.msg;
                _this.openMessageBox();
            }
        }, function (error) {
            _this.canSendCode = true;
            if (needSmsCaptcha) {
                var message = getErrorMsg(error);
                _this.tipMessage = message || '发送失败，请重试';
                _this.openMessageBox();
                _this.maybeRefreshCaptchaAfterError(message);
            }
        });
    };
    NewAppLoginComponent.prototype.openMessageBox = function () {
        var _this = this;
        this.messageBoxOpen = true;
        setTimeout(function () {
            _this.messageBoxOpen = false;
        }, 1500);
    };
    NewAppLoginComponent.prototype.resetFormElement = function (loginType) {
        if (loginType == 1) {
            this.accountName = '';
            this.accountPwd = '';
        }
        else {
            this.phoneNumber = '';
            this.phoneVerCode = '';
        }
    };
    //
    NewAppLoginComponent.prototype.handlePhoneOrAccountLogin = function () {
        var _this = this;
        if (!this.clickAble) {
            return;
        }
        this.clickAble = false;
        setTimeout(function () { _this.clickAble = true; }, 2000);
        // this.isOutLink = localStorage.getItem('openClass') ? true : false;
        this.isOutLink = this.platformLocation['location']['href'].indexOf('target_url=') === -1 ? false : true;
        this.submitData = {
            userName: this.accountName,
            password: this.accountPwd,
            phone: this.phoneNumber,
            verificationCode: this.phoneVerCode,
            type: 1,
            companyId: '',
        };
        if (this.isAICoach) {
            this.submitData['aiCoath'] = this.isAICoach;
        }
        if (this.signInAccount) {
            this.submitData.type = 1;
            this.submitData.phone = '';
            //账密
            this.validateAccountName(); //验证账户
            this.validateAccountPwd(); //密码
            if (this.accountNameInvalidTips || this.accountPwdInvalidTips) {
                return;
            }
            if (!this.validateCaptcha()) {
                return;
            }
        }
        else {
            this.submitData.type = 2; //修改手机验证码类型
            //手机号码
            this.validatePhoneNumber(); //验证手机号
            this.validatePhoneVerCode(); //验证验证码
            if (this.phoneNumberInvalidTips || this.phoneVerCodeInvalidTips) {
                return;
            }
            if (!this.validateCaptcha()) {
                return;
            }
        }
        if (!((this.signInAccount && this.isCheckedUser) || (this.signInPhone && this.isCheckedPhone))) {
            this.tipMessage = '请先勾选同意再登陆';
            this.openMessageBox();
            return;
        }
        // 账密标准流程：图形码预校验拿 challenge，再登录只带 challenge
        if (this.signInAccount && !this.isAICoach) {
            this.doAccountPrecheckThenLogin();
            return;
        }
        // 手机登录直连带图形码；智能陪练账密跳过图形码
        this.doLoginRequest(this.buildLoginSubmitData());
    };
    /**
     * 组装登录请求体。账密标准流只带 challenge；手机登录带明文图形码。
     */
    NewAppLoginComponent.prototype.buildLoginSubmitData = function () {
        var submitData = Object.assign({}, this.submitData);
        submitData.userName = this.commonService.encrypt(this.submitData.userName);
        submitData.password = this.commonService.encrypt(this.submitData.password);
        if (submitData.type === 2) {
            submitData.userName = this.phoneNumber;
            submitData.captchaCode = this.captchaCode;
            submitData.captchaNamespace = this.captchaNamespace;
            delete submitData.protectionChallengeToken;
        }
        else if (this.isAICoach) {
            delete submitData.captchaCode;
            delete submitData.captchaNamespace;
            delete submitData.protectionChallengeToken;
        }
        else {
            submitData.protectionChallengeToken = this.protectionChallengeToken;
            delete submitData.captchaCode;
            delete submitData.captchaNamespace;
        }
        if (!submitData.companyId) {
            delete submitData.companyId;
        }
        delete submitData.token;
        delete submitData.companySelectionToken;
        return submitData;
    };
    /** 账密：validateProtectionAccount → 暂存 challenge → login */
    NewAppLoginComponent.prototype.doAccountPrecheckThenLogin = function () {
        var _this = this;
        this.accountLoginDisabled = true;
        this.clearProtectionChallenge();
        this.apiService.validateProtectionAccount({
            userName: this.commonService.encrypt(this.submitData.userName),
            password: this.commonService.encrypt(this.submitData.password),
            type: 1,
            captchaCode: this.captchaCode,
            captchaNamespace: this.captchaNamespace
        }).subscribe(function (res) {
            var data = _this.getLoginData(res);
            var challenge = data.protectionChallengeToken;
            _this.maybeRefreshCaptchaAfterError();
            if (!challenge) {
                _this.accountLoginDisabled = false;
                var message = (res && res.msg) || '验证失败，请重试';
                _this.tipMessage = message;
                _this.openMessageBox();
                return;
            }
            _this.protectionChallengeToken = challenge;
            _this.doLoginRequest(_this.buildLoginSubmitData());
        }, function (error) {
            _this.accountLoginDisabled = false;
            var message = getErrorMsg(error);
            if (!message && error && error.status === 503) {
                message = 'Service Unavailable!';
            }
            _this.tipMessage = message || '验证失败，请重试';
            _this.openMessageBox();
            _this.maybeRefreshCaptchaAfterError(message);
        });
    };
    NewAppLoginComponent.prototype.doLoginRequest = function (submitData) {
        var _this = this;
        if (this.signInAccount) {
            this.accountLoginDisabled = true;
        }
        else {
            this.phoneLoginDisabled = true;
        }
        this.apiService.loginInPhoneOrAccount(submitData, { withToken: false }).subscribe(function (res) {
            var data = _this.getLoginData(res);
            if (data.need2FA && _this.signInAccount) {
                clearInterval(_this.timerInterval);
                _this.need2FAData = data;
                _this.isNeed2FA = true;
                _this.phoneVerCode = '';
                _this.accountNameInvalidTips = false;
                _this.accountPwdInvalidTips = false;
                _this.phoneNumberInvalidTips = false;
                _this.phoneVerCodeInvalidTips = false;
                _this.canSendCode = true;
                _this.phoneVerCodeRemainSeconds = '';
                _this.phoneVerCodeStateTxt = '获取验证码';
                //解除按钮禁用；中间态继续持有 challenge
                _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
                _this.need2FAPhoneNumber = data.twoFactorPhone;
                _this.twoFactoryPhone = data.twoFactorPhone;
                _this.maybeRefreshCaptchaAfterError();
                return;
            }
            // 登录接口 needChangePassword === true 时弹出强制改密
            if (_this.shouldForceChangePassword(res, data)) {
                _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
                _this.openForceChangePassword(data);
                return;
            }
            if (_this.submitData && Number(_this.submitData.type) === 2) {
                _this.maybeRefreshCaptchaAfterError();
            }
            _this.handleLoginSuccess(data, submitData);
        }, function (error) {
            // 部分环境可能以非 2xx 返回改密标记，需同样拦截
            var errBody = error && error.error ? error.error : error;
            var errData = _this.getLoginData(errBody);
            if (_this.shouldForceChangePassword(errBody, errData)) {
                _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
                _this.openForceChangePassword(errData);
                return;
            }
            //登录失败
            console.log('捕获页面错误---', error);
            var message = getErrorMsg(error);
            //添加对503响应的处理
            if (!message && error.status === 503) {
                message = 'Service Unavailable!';
            }
            _this.tipMessage = message;
            if (_this.submitData.type == 1) {
                _this.accountLoginDisabled = false;
            }
            else {
                _this.phoneLoginDisabled = false;
            }
            _this.resetFormElement(_this.submitData.type);
            _this.openMessageBox();
            _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
            _this.maybeRefreshCaptchaAfterError(message);
        });
    };
    NewAppLoginComponent.prototype.confirm2FA = function () {
        var _this = this;
        this.validatePhoneNumber(); //验证手机号
        this.validatePhoneVerCode(); //验证验证码
        if (this.phoneNumberInvalidTips || this.phoneVerCodeInvalidTips) {
            return;
        }
        var submitData = __assign({}, this.submitData);
        submitData.userName = this.commonService.encrypt(this.submitData.userName);
        submitData.password = this.commonService.encrypt(this.submitData.password);
        submitData.twoFactorPhone = this.need2FAPhoneNumber;
        submitData.verificationCode = this.phoneVerCode;
        submitData.type = 1;
        // challenge 与图形码二选一，中间态只回传 challenge
        if (this.protectionChallengeToken) {
            submitData.protectionChallengeToken = this.protectionChallengeToken;
        }
        delete submitData.captchaCode;
        delete submitData.captchaNamespace;
        if (!submitData.companyId) {
            delete submitData.companyId;
        }
        delete submitData.token;
        delete submitData.companySelectionToken;
        this.apiService.loginInPhoneOrAccount(submitData, { withToken: false }).subscribe(function (res) {
            var data = _this.getLoginData(res);
            _this.isNeed2FA = false;
            // 登录接口 needChangePassword === true 时弹出强制改密
            if (_this.shouldForceChangePassword(res, data)) {
                _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
                _this.openForceChangePassword(data);
                return;
            }
            _this.handleLoginSuccess(data, submitData);
        }, function (error) {
            var errBody = error && error.error ? error.error : error;
            var errData = _this.getLoginData(errBody);
            if (_this.shouldForceChangePassword(errBody, errData)) {
                _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
                _this.openForceChangePassword(errData);
                return;
            }
            //登录失败
            console.log('捕获页面错误---', error);
            var message = getErrorMsg(error);
            //添加对503响应的处理
            if (!message && error.status === 503) {
                message = 'Service Unavailable!';
            }
            _this.tipMessage = message;
            _this.resetFormElement(_this.submitData.type);
            _this.openMessageBox();
            _this.phoneLoginDisabled = _this.accountLoginDisabled = false;
        });
    };
    /**
     * 兼容 { success, data } 与扁平返回；保留顶层 needChangePassword 等标记
     */
    NewAppLoginComponent.prototype.getLoginData = function (res) {
        if (!res) {
            return {};
        }
        var loginData = res;
        if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
            if (Object.prototype.hasOwnProperty.call(res.data, 'needChangePassword') ||
                Object.prototype.hasOwnProperty.call(res.data, 'token') ||
                Object.prototype.hasOwnProperty.call(res.data, 'need2FA') ||
                Object.prototype.hasOwnProperty.call(res.data, 'userId') ||
                Object.prototype.hasOwnProperty.call(res.data, 'protectionChallengeToken') ||
                Object.prototype.hasOwnProperty.call(res.data, 'companySelectionToken')) {
                loginData = Object.assign({}, res.data);
            }
        }
        // 顶层改密标记可能与 data 并存，解包后需合并回去
        if (res.needChangePassword === true) {
            loginData.needChangePassword = true;
        }
        if (res.weakPasswordReasonCode) {
            loginData.weakPasswordReasonCode = res.weakPasswordReasonCode;
        }
        if (res.weakPasswordReasonText) {
            loginData.weakPasswordReasonText = res.weakPasswordReasonText;
        }
        if (res.token && !loginData.token) {
            loginData.token = res.token;
        }
        if (res.protectionChallengeToken && !loginData.protectionChallengeToken) {
            loginData.protectionChallengeToken = res.protectionChallengeToken;
        }
        if (res.companySelectionToken && !loginData.companySelectionToken) {
            loginData.companySelectionToken = res.companySelectionToken;
        }
        if (res.companyList && !loginData.companyList) {
            loginData.companyList = res.companyList;
        }
        return loginData;
    };
    NewAppLoginComponent.prototype.shouldForceChangePassword = function (res, loginData) {
        var data = loginData || res || {};
        return !!((res && res.needChangePassword === true) ||
            data.needChangePassword === true);
    };
    NewAppLoginComponent.prototype.openForceChangePassword = function (loginData) {
        this.pendingLoginRes = loginData ? JSON.parse(JSON.stringify(loginData)) : {};
        // 改密接口通常需要登录态，先落 token
        if (loginData && loginData.token) {
            localStorage.setItem('transtalen-token', loginData.token);
            if (loginData.userIdEncoder) {
                localStorage.setItem('transtalenuserid', loginData.userIdEncoder);
            }
            this.apiService.setHeaders();
        }
        this.isNeedChangePassword = true;
        // 占用一条历史记录：回退时先取消未完成改密，避免带着临时 token 直接进入系统
        try {
            history.pushState({ forceChangePassword: true }, document.title, location.href);
            this.forceChangeHistoryPushed = true;
        }
        catch (e) {
            this.forceChangeHistoryPushed = false;
        }
        this.cdr.detectChanges();
    };
    /**
     * 浏览器回退：强制改密未完成时清理临时登录态，回到登录表单
     */
    NewAppLoginComponent.prototype.onPopState = function () {
        if (this.isNeedChangePassword) {
            this.cancelForceChangePassword();
        }
    };
    /**
     * 取消强制改密（回退/离开页面）：清除临时 token，避免绕过改密
     */
    NewAppLoginComponent.prototype.cancelForceChangePassword = function () {
        this.isNeedChangePassword = false;
        this.pendingLoginRes = null;
        this.forceChangeHistoryPushed = false;
        localStorage.removeItem('transtalen-token');
        localStorage.removeItem('transtalenuserid');
        this.apiService.setHeaders();
        this.clearProtectionChallenge();
        this.refreshCaptcha();
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
        this.cdr.detectChanges();
    };
    /** 关闭改密页，回到登录页，不完成登录 */
    NewAppLoginComponent.prototype.onForceChangePasswordClose = function () {
        var pushed = this.forceChangeHistoryPushed;
        this.cancelForceChangePassword();
        if (pushed) {
            history.back();
        }
    };
    /**
     * 强制改密确认后：updatePassword 成功即可进入。
     * 产品约定 needChangePassword=true 时首次登录已视为登录成功，无需再调 login。
     */
    NewAppLoginComponent.prototype.onForceChangePasswordSuccess = function (_a) {
        var _this = this;
        var plainNewPassword = _a.plainNewPassword, currentPassword = _a.currentPassword, newPassword = _a.newPassword;
        this.accountPwd = plainNewPassword || this.accountPwd;
        this.submitData.password = this.accountPwd;
        // 文档约定：updatePassword 仅传 currentPassword、newPassword（均已加密）
        this.apiService.updatePassword({
            currentPassword: currentPassword,
            newPassword: newPassword
        }).subscribe(function () {
            var loginRes = Object.assign({}, _this.pendingLoginRes || {});
            loginRes.needChangePassword = false;
            // 先结束强制改密态，避免后续跳转/回退被当成“未完成改密”清掉 token
            _this.isNeedChangePassword = false;
            _this.pendingLoginRes = null;
            _this.forceChangeHistoryPushed = false;
            var submitData = Object.assign({}, _this.submitData);
            submitData.userName = _this.commonService.encrypt(_this.submitData.userName);
            submitData.password = _this.commonService.encrypt(_this.submitData.password);
            _this.handleLoginSuccess(loginRes, submitData);
        }, function (error) {
            var message = error && error.error && error.error.msg;
            if (!message && error && error.status === 503) {
                message = 'Service Unavailable!';
            }
            _this.tipMessage = message || '修改密码失败，请稍后重试';
            _this.openMessageBox();
            if (_this.forcePwdComp) {
                _this.forcePwdComp.resetSubmitting();
            }
        });
    };
    NewAppLoginComponent.prototype.ngOnDestroy = function () {
        // 组件销毁时若仍处于强制改密，清理临时登录态，防止绕过
        if (this.isNeedChangePassword) {
            localStorage.removeItem('transtalen-token');
            localStorage.removeItem('transtalenuserid');
            this.apiService.setHeaders();
            this.clearProtectionChallenge();
            this.isNeedChangePassword = false;
            this.pendingLoginRes = null;
            this.forceChangeHistoryPushed = false;
        }
    };
    NewAppLoginComponent.prototype.persistLoginCredentialsFromForm = function () {
        var account = this.submitData.type === 2
            ? (this.phoneNumber || this.submitData.phone || '')
            : (this.accountName || this.submitData.userName || '');
        var password = this.accountPwd || this.submitData.password || '';
        this.commonService.persistLoginCredentials(account, password, this.submitData.type);
    };
    /** 多公司中间态写入 loginData：只存短票 + 公司列表，禁止写入正式 token / 图形码 */
    NewAppLoginComponent.prototype.prepareLoginDataForCompanySelect = function () {
        var stored = Object.assign({}, this.submitData);
        stored.userName = this.submitData.type === 2
            ? (this.phoneNumber || this.submitData.phone || '')
            : (this.accountName || this.submitData.userName || '');
        stored.password = this.commonService.xorEncrypt(this.accountPwd || this.submitData.password || '', this.commonService.xorKey);
        delete stored.captchaCode;
        delete stored.captchaNamespace;
        delete stored.verificationCode;
        delete stored.token;
        delete stored.companyId;
        if (this.protectionChallengeToken) {
            stored.protectionChallengeToken = this.protectionChallengeToken;
        }
        return stored;
    };
    NewAppLoginComponent.prototype.persistMultiCompanySelectState = function (data) {
        var stored = this.prepareLoginDataForCompanySelect();
        stored.companyList = data && data.companyList ? data.companyList : [];
        stored.companySelectionToken = data && data.companySelectionToken ? data.companySelectionToken : '';
        stored.phone = this.phoneNumber || stored.phone || stored.userName;
        localStorage.setItem('loginData', JSON.stringify(stored));
        localStorage.removeItem('transtalen-token');
        this.apiService.setHeaders();
    };
    NewAppLoginComponent.prototype.handleLoginSuccess = function (data, submitData) {
        //解除按钮禁用
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
        this.persistLoginCredentialsFromForm();
        //删掉登录信息记录
        localStorage.removeItem('loginData');
        console.log(data, '登录接口返回------------------------------------');
        var loggedIn = hasFormalLoginToken(data);
        var hasManyCompany = this.hasMultiValidCompany(data);
        if (loggedIn) {
            localStorage.setItem('transtalen-token', data.token);
            if (data.userIdEncoder) {
                localStorage.setItem('transtalenuserid', data.userIdEncoder);
            }
            this.apiService.setHeaders(); //header设置
            // 最终拿到正式登录态后丢弃 challenge
            this.clearProtectionChallenge();
        }
        if (data.redirectUrl) {
            this.clearProtectionChallenge();
            this.platformLocation['location']['href'] = data.redirectUrl;
        }
        else {
            if (this.isOutLink) {
                if (!loggedIn && hasManyCompany) {
                    this.persistMultiCompanySelectState(data);
                    this.router.navigate(['/course-select'], { queryParams: {
                            notSelectCompany: 'yes'
                        } });
                    return;
                }
                if (data.status === 0) {
                    this.clearProtectionChallenge();
                    this.router.navigate(['/learning-map']);
                    localStorage.removeItem('targetUrl');
                }
                else {
                    localStorage.setItem('openClass', '1');
                    localStorage.setItem('targetUrl', this.targetUrl);
                    this.clearProtectionChallenge();
                    localStorage.setItem('userId', data.userId);
                    //增加一个条件，如果当前target_url里包含leadershipcoach这个字符串，则认为是要直接跳转到导师的，将token替换进去之后跳到target_url
                    if (this.platformLocation['location']['href'].indexOf('leadershipcoach') !== -1) {
                        var targetUrl = this.commonService.extractTargetUrlAndAddToken(window.location.href, data.token);
                        console.log('targetUrl', targetUrl);
                        window.location.href = targetUrl;
                    }
                    else {
                        if (this.commonService.getQueryString('isIntelligent')) {
                            //这里不能直接跳到智能陪练列表页，因为target_url里没有token,需要将token字段进行替换之后再跳转
                            console.log('target_url', decodeURIComponent(this.commonService.getQueryString('target_url')));
                            var url = new URL(decodeURIComponent(this.commonService.getQueryString('target_url')));
                            var newUrl = url.toString();
                            window.location.href = decodeURIComponent(newUrl);
                        }
                        else {
                            this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?token=' + data.token + '&' + this.targetUrl;
                        }
                    }
                }
            }
            else {
                localStorage.removeItem('openClass');
                localStorage.removeItem('targetUrl');
                localStorage.removeItem('exerciseGroup');
                localStorage.removeItem('pdfList');
                localStorage.removeItem('uploadList');
                localStorage.removeItem('uploadId');
                localStorage.removeItem('canSave');
                if (loggedIn) {
                    this.clearProtectionChallenge();
                    this.router.navigate(['/learning-map']);
                }
                else if (hasManyCompany) {
                    this.persistMultiCompanySelectState(data);
                    this.router.navigate(['/course-select'], { queryParams: {
                            notSelectCompany: 'yes'
                        } });
                }
            }
        }
    };
    NewAppLoginComponent.prototype.hasMultiValidCompany = function (data) {
        var list = data && Array.isArray(data.companyList) ? data.companyList : [];
        return list.filter(function (item) { return item.state === 1; }).length > 1;
    };
    NewAppLoginComponent.prototype.showVersion = function () {
        this.count++;
        if (this.count > 10) {
            var vConsole = new VConsole();
            this.count = 0;
        }
    };
    NewAppLoginComponent.prototype.check = function () {
        this.isCheckedUser = $('#checkUser').is(':checked');
        this.isCheckedPhone = $('#checkPhone').is(':checked');
    };
    NewAppLoginComponent.prototype.closePopover = function () {
        clearInterval(this.timerInterval);
        this.isNeed2FA = false;
        if (this.need2FAPhoneNumber) {
            this.need2FAPhoneNumber = '';
            this.twoFactoryPhone = '';
        }
        clearInterval(this.timerInterval);
        this.phoneVerCode = '';
        this.accountNameInvalidTips = false;
        this.accountPwdInvalidTips = false;
        this.phoneNumberInvalidTips = false;
        this.phoneVerCodeInvalidTips = false;
        this.canSendCode = true;
        this.phoneVerCodeRemainSeconds = '';
        this.phoneVerCodeStateTxt = '获取验证码';
        //解除按钮禁用
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
    };
    NewAppLoginComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    return NewAppLoginComponent;
}());
export { NewAppLoginComponent };



// WEBPACK FOOTER //
// ./src/app/new-app-login/new-app-login.component.ts.pre-build-optimizer.js